
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.453 2.4H6.371a2.226 2.226 0 00-2.226 2.226v14.095c-.06 2.537 3.71 3.827 5.75 2.314.222-.044 9.294-6.832 9.48-6.906a.839.839 0 00.304-.601V4.626A2.226 2.226 0 0017.453 2.4zM7.113 9.82a.741.741 0 01.741-.742h8.16a.742.742 0 110 1.484h-8.16a.742.742 0 01-.742-.742zm6.676-2.226h-3.71a.742.742 0 010-1.483h3.71a.742.742 0 110 1.483zm-2.537 10.638v-3.22a.742.742 0 01.742-.741h4.673l-5.415 3.961z","fill":"#B5B8B5"}})])
          )
        }
      }
    